import AbstractCommand from '../AbstractCommand';
import offersGet from '../../requests/offers/offersGet';
import OfferModel from '../../stores/models/OfferModel';

/**
 *
 */
export default class GetOffersCommand extends AbstractCommand {
	/**
	 *
	 * @param offersStore offersStore
	 * @param companyId Number
	 */
	constructor(offersStore, companyId) {
		super();

		this.offersStore = offersStore;
		this.companyId = companyId;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return offersGet(this.companyId)
			.then((response) => {
				this._parseResult(response);

				if (success) {
					success(response);
				}
			})
			.catch((err) => {
				if (error) {
					error(err);
				}
			});
	}

	/**
	 *
	 * @param response
	 * @private
	 */
	_parseResult(response) {
		this.offersStore.reset();
		const offers = [];
		response.list.forEach((data) => {
			offers.push(OfferModel.parseOfferData(data));
		});

		this.offersStore.addAll(offers);
	}
}
